import { handleApiError } from '@api';
import config from '@config';
import { HTTPClient } from '@platform2-lib/httpz';
import * as schema from '@schema';
import type { ArtifactResponse } from 'types/schema';

const client = new HTTPClient(
  config.env,
  `${config.api.origin}/spark-agent-v2`
);

async function getArtifact(artifactId: string): Promise<ArtifactResponse> {
  try {
    const response = await client.get(
      `/artifacts/versions/${artifactId}`,
      schema.ArtifactResponse
    );

    return response;
  } catch (error: unknown) {
    handleApiError(error, `Failed to retrieve artifact '${artifactId}'.`, true);
  }
}

export const artifacts = {
  getArtifact
};
